import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-atom-why-image-uploader',
  template: `
    <section>
      <div class="image-upload-container">
        <div>
          <app-why-file-uploader
            [uploadUrl]="fileUploadUrl"
            [fileFormats]="['jpg', 'jpeg', 'png', 'JPG']"
            [fileType]="['image']"
            [allowRetry]="true"
            [maxFileSize]="1e+9"
            [disabled]="false"
            [imgPath]="profileImage"
            (isFileUploadInProgress)="fileUploadingFunction($event)"
            (isUploadDone)="onFileUploadDoneFunction($event)"
            (isValidationError)="onFileUploadErrorFunction($event)">
          </app-why-file-uploader>
        </div>
        <div class="placeholder-icon" *ngIf="profileImage === ''">
          <ion-icon class="icon" name="add-outline"></ion-icon>
        </div>
      </div>
    </section>
  `,
  styleUrls: ['./atom-image-uploader.component.scss']
})

export class AtomImageUploaderComponent implements OnChanges {
  @Input() profileImage = '';
  @Input() placeHolderText = 'COMPANY\'S PHOTO';
  @Input() fileUploadUrl = environment.server + '/api/emotion-reports/upload';
  @Output() fileUploading: EventEmitter<any> = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onFileUploadDone: EventEmitter<any> = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onFileUploadError: EventEmitter<any> = new EventEmitter<any>();
  isFileUploaded = false;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.isFileUploaded = !!this.profileImage;
  }

  fileUploadingFunction(event) {
    this.isFileUploaded = true;
    this.fileUploading.emit(event);
  }

  onFileUploadDoneFunction($event: any) {
    this.onFileUploadDone.emit($event);
  }

  onFileUploadErrorFunction(event: any) {
    this.onFileUploadError.emit(event);
  }
}
